import { parseReviewImages, type ReviewImage } from '@/lib/campaigns/reviewImages';

/**
 * Images the disapprove panel starts with. Re-disapproving an already
 * disapproved row prefills its saved images so confirming (e.g. to fix a
 * reason typo) does not wipe them; any other row starts empty.
 */
export function initialDisapproveImages(
  submission: { admin_approval?: string | null; rejection_images?: unknown } | null | undefined,
): ReviewImage[] {
  if (!submission || submission.admin_approval !== 'disapproved') return [];
  return parseReviewImages(submission.rejection_images);
}
